import { render, staticRenderFns } from "./SystemSettingTerminalEditor.vue?vue&type=template&id=ec328e10&scoped=true&"
import script from "./SystemSettingTerminalEditor.vue?vue&type=script&lang=ts&"
export * from "./SystemSettingTerminalEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSettingTerminalEditor.vue?vue&type=style&index=0&id=ec328e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec328e10",
  null
  
)

export default component.exports